module.exports = __webpack_public_path__ + "static/media/lo_zwarte_els.930d1280.svg";